import { j as r } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { Alert as t } from "@mui/joy";
import { memo as m } from "react";
import { S as e } from "../../../../../../index.BRz-o-Vs.js";
const s = m(({
  syncDirection: o
}) => /* @__PURE__ */ r.jsx(t, { children: o === e.IMPORT ? null : o === e.EXPORT ? "Export your audiences directly to your Adform DSP seat. Please make sure to use this only with Adform-supported ID types. For details, please check the documentation." : null }));
s.displayName = "AdformInfo";
export {
  s as default
};
//# sourceMappingURL=AdformInfo.js.map
